import React from 'react';

import ProductCategoryShow from '@shared/product_categories/ProductCategoryShow';
import { useLoaderData } from 'react-router-dom';

import productCategoryService from '@services/operator/productCategoryService';

export default function OperatorProductCategoryShow() {
  const productCategory = useLoaderData();

  return (
    <ProductCategoryShow
      productCategory={productCategory}
      productCategoryService={productCategoryService}
      role="operator"
      basePath="/product_categories"
    />
  );
}
